import React from "react";
import { ShieldCheck } from 'lucide-react';

export const Header = () => {
    return (
        <div className="flex items-center space-x-3">
            
            <div className="service-icon bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(175,70%,50%)]">
                <ShieldCheck className="w-5 h-5 text-white" />
            </div>
            <div>
                <h1 className="text-xl font-heading font-semibold bg-gradient-to-r from-[hsl(210,100%,45%)] to-[hsl(175,70%,50%)] bg-clip-text text-transparent">
                    ADA Compliance System
                </h1>
                <p className="text-xs text-muted-foreground">Monitor and ensure accessibility compliance</p>
            </div>
        </div>
    );
};